import { UserRound } from "lucide-react";
import { PartnerGrowthIncentiveItem } from "../../../../Redux/referral/types";
import {
  formatEarningsCurrency,
  formatEarningsDate,
  normalizeEarningsStatus,
  statusLabel,
} from "../earningsAdapters";

const statusClass = (status: string) =>
  `partner-growth-status partner-growth-status-${normalizeEarningsStatus(status)}`;

interface Props {
  data: PartnerGrowthIncentiveItem[];
  loading?: boolean;
}

const PartnerGrowthIncentiveTable = ({ data, loading }: Props) => {
  return (
    <div className="partner-growth-desktop-table-wrap">
      <table className="partner-growth-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>DATE</th>
            <th>MY PARTNER NAME</th>
            <th>MY PARTNER GROWTH REFERRAL INCENTIVES</th>
            <th>TDS</th>
            <th>NET AMOUNT</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          ) : data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>
                  <span className="partner-growth-serial">{item.sNo}</span>
                </td>
                <td>
                  <strong className="partner-growth-date">
                    {formatEarningsDate(item.date)}
                  </strong>
                </td>
                <td>
                  <div className="partner-growth-partner-cell">
                    <span className="partner-growth-avatar">
                      <UserRound size={17} />
                    </span>
                    <strong>
                      {item.myPartnerName}
                      {item.myPartnerRegisterId
                        ? ` (${item.myPartnerRegisterId})`
                        : ""}
                    </strong>
                  </div>
                </td>
                <td>
                  <strong className="partner-growth-money">
                    {formatEarningsCurrency(
                      item.grossAmount ?? item.myPartnerGrowthReferralIncentives,
                    )}
                  </strong>
                </td>
                <td>
                  <strong className="partner-growth-money">
                    {formatEarningsCurrency(item.tdsAmount ?? 0)}
                    {item.tdsIsEstimated ? " (est)" : ""}
                  </strong>
                </td>
                <td>
                  <strong className="partner-growth-money">
                    {formatEarningsCurrency(
                      item.netAmount ?? item.myPartnerGrowthReferralIncentives,
                    )}
                  </strong>
                </td>
                <td>
                  <span className={statusClass(item.status)}>
                    {statusLabel(item.status)}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7}>No partner growth incentives found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PartnerGrowthIncentiveTable;
